export const products = [
  {
    linkUrl: "/products/vista-iwa",
    imageFileName: "imgnotavailable.png",
    imageUrl: "",
    cardTitle: "Vista IWA",
    cardContent:
      "Vista IWA (Dr. Vista 108 IWA+) is a unique, multipurpose, advanced technology integral waterproofing compound. It is made from specially formulated cement-friendly surface-active agents, corrosion-inhibiting additives, and polymers. Designed to be added to cement concrete, mortar, and plasters, Vista IWA enhances water resistance by sealing the concrete against capillary absorption and preventing water ingress.",
    category: "Construction Aids & Accessories",
  },
  {
    linkUrl: "/products/vista-no-2",
    imageUrl: "",
    imageFileName: "imgnotavailable.png",
    cardTitle: "Vista No. 2",
    cardContent:
      "Vista No. 2 is an extra-fast setting, waterproof plugging compound in liquid form. It is a time-tested liquid admixture designed for emergency or immediate repair work, including instant leak plugging and quick nozzle fixing applications.",
    category: "Concrete Admixtures",
    subcategory: "Accelerators",
  },
  {
    linkUrl: "/products/vista-flex-seal-plus",
    imageUrl: "",
    imageFileName: "vistaflexsealplus.png",
    cardTitle: "Vista Flex Seal +",
    cardContent:
      "Vista Flex Seal+ is a cementitious waterproofing coating that comes as a ready-to-use two-component system—comprising carefully graded aggregates and selected acrylic polymers. It is highly recommended for waterproofing concrete.",
    category: "Waterproofing Compounds",
  },
  {
    linkUrl: "/products/vista-crystal-plus",
    imageUrl: "",
    imageFileName: "vistacrystalplus.png",
    cardTitle: "Vista Crystal Plus",
    cardContent:
      "Vista Crystal Plus is a crystalline waterproofing admixture that protects and waterproofs concrete structures through crystallization. The active chemicals react with moisture and the by-products of cement hydration in the concrete, resulting in crystalline formation within the pores and capillary tracts of concrete. This waterproofs the structure against the penetration of water and other liquids from any direction. Crystal Plus provides strong and lasting protection against harsh environmental conditions. When combined with water, the chemicals form millions of needle-like crystals within the concrete, filling pores and micro-cracks, and effectively blocking water pathways.",
    category: "Crystallization Compounds",
  },
  {
    linkUrl: "/products/vista-no-3",
    imageUrl: "",
    imageFileName: "imgnotavailable.png",
    cardTitle: "Vista No. 3",
    cardContent:
      "Vista No. Three is a multipurpose quick-setting liquid additive for cement mortar and concrete. When added, it accelerates the setting process, resulting in rapid hardening, making it ideal for urgent repairs and construction in wet or time-restricted environments.",
    category: "Concrete Admixtures",
    subcategory: "Accelerators",
  },
  {
    linkUrl: "/products/vista-power-silica-fume",
    imageUrl: "",
    imageFileName: "vistapowersilicafume.png",
    cardTitle: "Vista Power Silica Fume",
    cardContent:
      "VISTA PowerX Silica Fume is a densified silica fume designed to produce extremely strong, durable concrete. It complies with ASTM C 1240 specifications.",
    category: "Construction Aids & Accessories",
  },
  {
    linkUrl: "/products/vista-superplast-hs-1000",
    imageUrl: "",
    imageFileName: "vistasuperplasths1000.png",
    cardTitle: "Vista Superplast HS 1000",
    cardContent:
      "VISTA SUPERPLAST HS is a unique multipurpose advance technology high-performance Super-plasticizing Accelerating admixture based on modified poly carboxylate ether conforming to ASTM C494.",
    category: "Concrete Admixtures",
    subcategory: "Plastisizers",
  },
  {
    linkUrl: "/products/vista-afa-super",
    imageUrl: "",
    imageFileName: "imgnotavailable.png",
    cardTitle: "Vista AFA Super",
    cardContent:
      "Dr Vista AFA Super is an alkali free accelerator especially used for wet shotcrete applications. It starts up a sudden drop of slump and a thixotropic effect at the time of spraying. The reaction with cement particles is immediate.",
    category: "Concrete Admixtures",
    subcategory: "Accelerators",
  },
  {
    linkUrl: "/products/vista-crack-stop",
    imageFileName: "imgnotavailable.png",
    imageUrl: "",
    cardTitle: "Vista Crack Stop",
    cardContent:
      "The Crack stop range of monofilament polypropylene fibres reduce the occurrence of plastic shrinkage and plastic settlement cracking, whilst enhancing the surface properties and durability of hardened cementitious products. The fibres are coated with surfactant to improve initial dispersion within the cementitious materials.",
    category: "Construction Aids & Accessories",
  },
  {
    linkUrl: "/products/vista-superplast",
    imageUrl: "",
    imageFileName: "vistasuperplast.png",
    cardTitle: "Vista Superplast",
    cardContent:
      "Vista Superplast is a high water reducer and slump retaining admixture formulated using Sulphonated Naphthalene Formaldehyde, that is supplied as a light brown liquid suitable for concreting in all climates. Its special formulation allows for water reductions without any loss to workability, and also to produce higher quality concrete with reduced permeability. Vista Superplast complies with IS-9103: 1999 and BS: 5075 part 3, and also with ASTM-C-494 Type 'F' and Type 'A' depending on the dosages used.",
    category: "Concrete Admixtures",
    subcategory: "Plastisizers",
  },
  {
    linkUrl: "/products/vista-superplast-pqc",
    imageUrl: "",
    imageFileName: "imgnotavailable.png",
    cardTitle: "Vista Superplast-PQC",
    cardContent:
      "Vista Superplast PQC is a Latest Technology high-performance Superplasticiser for Pavement Quality Concrete based on Modified poly carboxylate ether suitable for concreting in hot climates confirming to IS 9103: 1999; ASTM C494.",
    category: "Concrete Admixtures",
    subcategory: "Plastisizers",
  },
  {
    linkUrl: "/products/vista-superplast-scc",
    imageUrl: "",
    imageFileName: "imgnotavailable.png",
    cardTitle: "Vista Superplast-SCC",
    cardContent:
      "Vista Superplast SCC is a high-performance superplasticizer used to produce self-compacting concrete with high consistence values. It is particularly useful in precast operations, flooring, and when pouring into intricate or heavily congested areas of reinforcement. Vista Superplast SCC enhances cement dispersion, creating non-shrinkable concrete with high water reduction and workability retention. It conforms to IS: 9103: 1999 (Reaffirmed 2004) and ASTM C494, Type F.",
    category: "Concrete Admixtures",
    subcategory: "Plastisizers",
  },
  {
    linkUrl: "/products/vista-superplast-hs-500",
    imageUrl: "",
    imageFileName: "vistasuperplasths500.png",
    cardTitle: "Vista Superplast HS 500",
    cardContent:
      "Vista Super Plast HS 500 is a high range water reducing admixture formulated specifically to extend the working time of flowing concrete at high temperatures. Vista Super Plast HS 500 does not contain calcium chloride or any other ingredients that would promote corrosion.",
    category: "Concrete Admixtures",
    subcategory: "Plastisizers",
  },
  {
    linkUrl: "/products/vista-mrob",
    imageUrl: "",
    imageFileName: "vistamrob.png",
    cardTitle: "Vista MR-OB",
    cardContent:
      "Vista MR-OB is a low viscous mineral oil based shutter release agent. Ready for direct application and use.",
    category: "Construction Aids & Accessories",
  },
  {
    linkUrl: "/products/vista-pumpcare",
    imageUrl: "",
    imageFileName: "imgnotavailable.png",
    cardTitle: "Vista Pump-Care",
    cardContent:
      "Vista Pump Care is a dry polymer based powder concrete pump primer, easily miscible in water and is available in pre-measured pack. It is uniquely formulated to provide the concrete pumper with a cost effective method for improving the pump ability of hard to pump and/or harsh concrete and grout mixes.",
    category: "Construction Aids & Accessories",
  },
  {
    linkUrl: "/products/vista-sbr-latex-plus",
    imageUrl: "",
    imageFileName: "vistasbrlatexplus.png",
    cardTitle: "Vista SBR Latex Plus",
    cardContent:
      "Dr. Vista SBR Latex Plus is a milky-white, styrene-butadiene co~polymer latex liquid designed to improve waterproofing, bonding, and the physical properties of cementitious mortars, screeds, and concrete. It enhances durability, compressive strength, and tensile and flexural properties. Suitable for vertical and horizontal applications, both internal and external. Meets BS 6319 part II:1983 & ASTM C 190-85 standards.",
    category: "Waterproofing Compounds",
  },
  {
    linkUrl: "/products/vista-super-crete",
    imageUrl: "",
    imageFileName: "vistasupercrete.png",
    cardTitle: "Vista Super Crete",
    cardContent:
      "Vista Super Crete is an acrylic polymer-based cementitious coating and repairing compound. When used as recommended, it combines with cement and fine sand to form an impermeable coating by blocking the capillaries and pores of the concrete substrate. It is also UV resistant.",
    category: "Waterproofing Compounds",
  },
  {
    linkUrl: "/products/vista-shot-x",
    imageUrl: "",
    imageFileName: "vistashotx.png",
    cardTitle: "Vista Shot X",
    cardContent:
      "A ready to use alkali free accelerator in powder form for use with dry gunite mixes. It allows spraying to take place even on wet surfaces subject to slight infiltration.",
    category: "Concrete Admixtures",
    subcategory: "Accelerators",
  },
];

export const sortedProducts = products.sort((a, b) => {
  const categoryComparison = a.category.localeCompare(b.category);
  if (categoryComparison !== 0) return categoryComparison;

  const aHasImage = a.imageFileName !== "imgnotavailable.png";
  const bHasImage = b.imageFileName !== "imgnotavailable.png";

  if (aHasImage && !bHasImage) return -1;
  if (!aHasImage && bHasImage) return 1;

  return a.cardTitle.localeCompare(b.cardTitle);
});
